import { render, staticRenderFns } from "./AppViewerPDF.vue?vue&type=template&id=506e7125&scoped=true&"
import script from "./AppViewerPDF.vue?vue&type=script&lang=ts&"
export * from "./AppViewerPDF.vue?vue&type=script&lang=ts&"
import style0 from "./AppViewerPDF.vue?vue&type=style&index=0&id=506e7125&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e7125",
  null
  
)

export default component.exports